import { IPosition } from '~views/components/interfaces';

const classNames = require('classnames');

export const classes = (component: string, ...otherClassNames: (string | undefined)[]) =>
    classNames(`elc-${component}`, `js-${component}`, otherClassNames);

export const addFullBleed = (position: IPosition['position']) =>
    position?.extend ? 'fullbleed' : '';
